class CollectionCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.collection-carousel__track');
    this.cards = Array.from(this.track.children);
    this.sliderContainer = container.closest('.collection-carousel__slider-container');
    this.prevBtn = this.sliderContainer?.querySelector('.collection-carousel__arrow--prev');
    this.nextBtn = this.sliderContainer?.querySelector('.collection-carousel__arrow--next');

    this.autoplay = container.dataset.autoplay === 'true';
    this.speed = parseInt(container.dataset.speed || 4) * 1000;
    this.loop = container.dataset.loop === 'true';

    this.currentIndex = 0;
    this.autoplayTimer = null;

    this.init();
  }

  init() {
    if (this.cards.length === 0) return;

    this.updateLayout();
    this.positionArrows();
    this.bindEvents();
    this.goTo(0, false);

    if (this.autoplay) this.startAutoplay();

    window.addEventListener('resize', this.debounce(() => {
      this.updateLayout();
      this.positionArrows();
      this.goTo(this.currentIndex, false);
    }, 120));
  }

  positionArrows() {
    if (!this.prevBtn || !this.nextBtn) return;

    const firstImage = this.cards[0]?.querySelector('.collection-carousel__image-wrapper');
    if (!firstImage) return;

    const imageHeight = firstImage.offsetHeight;
    const top = imageHeight / 2;

    this.prevBtn.style.top = `${top}px`;
    this.nextBtn.style.top = `${top}px`;
    this.prevBtn.style.transform = 'translateY(-50%)';
    this.nextBtn.style.transform = 'translateY(-50%)';
  }

  updateLayout() {
    const card = this.cards[0];
    if (!card) return;

    const style = getComputedStyle(this.track);
    const gap = parseFloat(style.gap) || 20;

    this.cardWidth = card.getBoundingClientRect().width + gap;
    this.visibleCards = Math.round(this.container.offsetWidth / this.cardWidth) || 1;
    this.maxIndex = Math.max(0, this.cards.length - this.visibleCards);
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }

    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    let startX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
      this.stopAutoplay();
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) > 40) {
        if (diff > 0) this.next();
        else this.prev();
      }

      isDragging = false;
      if (this.autoplay) this.startAutoplay();
    }, { passive: true });
  }

  goTo(index, animate = true) {
    if (this.loop) {
      if (index < 0) index = this.maxIndex;
      if (index > this.maxIndex) index = 0;
    } else {
      index = Math.max(0, Math.min(index, this.maxIndex));
    }

    this.currentIndex = index;
    const offset = -(this.currentIndex * this.cardWidth);

    this.track.style.transition = animate
      ? 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';

    this.track.style.transform = `translateX(${offset}px)`;
  }

  next() { this.goTo(this.currentIndex + 1); }
  prev() { this.goTo(this.currentIndex - 1); }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-carousel__slider').forEach(slider => {
    new CollectionCarousel(slider);
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const slider = e.target.querySelector('.collection-carousel__slider');
  if (slider) new CollectionCarousel(slider);
});